import React from "react";

const Pagination = ({
  numberPerPage,
  totalArticles,
  paginate,
  currentPage,
}) => {
  let pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalArticles / numberPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <ul className="pagination">
      {pageNumbers.map((number) => {
        return (
          <li
            key={number}
            onClick={() => paginate(number)}
            className={
              currentPage === number
                ? "pagination_list active"
                : "pagination_list"
            }
          >
            {number}
          </li>
        );
      })}
    </ul>
  );
};

export default Pagination;
